import type React from 'react';

import '@change/ds-core-ui/styles.css';
import '@change/ds-forms/styles.css';
import '@change/ds-icons/styles.css';
import '@change/ds-layout/styles.css';
import '@change/ds-maps/styles.css';
import './index.css';

// Global CSS reset/base styles (no Tailwind hook available, and we no longer use emotion/theme-ui).
// Injected via a plain <style> element.
const STYLES = `
@layer base {
	body {
		padding: 0;
		margin: 0;
		font-family: 'Commissioner', 'Helvetica Neue', Helvetica, Arial, Tahoma, sans-serif;
	}

	/* css-only inert polyfill */
	/* https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/inert */
	/* add https://github.com/WICG/inert full polyfill for the Element.inert support */
	[inert],
	[inert] * {
		user-select: none;
	}
	[inert] {
		pointer-events: none;
		cursor: default;
	}

	/* FIXME temporary fix to hide outline caused when navigating */
	/* from the DS header */
	/* TODO investigate why this happens */
	[data-maincontent]:focus,
	[data-maincontent-principal]:focus {
		outline: none;
	}
}
`;

export const AppGlobalStyle: React.FC<EmptyProps> = () => {
	// eslint-disable-next-line react/no-danger
	return <style dangerouslySetInnerHTML={{ __html: STYLES }} />;
};
